import { jsx as _jsx } from "react/jsx-runtime";
export default function Simple(_a) {
    var message = _a.message;
    return _jsx("p", { className: "message", children: message });
}
